// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class UserAPI extends MainAPI {
	/**
	 * @param {*} userEmail
	 */
	async getLoggedInUser(userEmail) {
		return API.get(`${ENDPOINTS.GET_LOGGED_IN_USER}/${userEmail}`);
	}

	/**
	 * @param {*} userId, body
	 */
	async putUserDetails(userId, body) {
		return API.put(`${ENDPOINTS.PUT_USER}/${userId}`, body);
	}

	/**
	* @param {*} userQuery
	*/
	async getUserList(userQuery) {
		return API.get(`${ENDPOINTS.GET_LOGGED_IN_USER}?${queryString.stringify(userQuery)}`);
	}

	/**
	* @param {*} userId
	* @param {*} statusDetails
	*/
	async putUserStatus(userId, statusDetails) {
		return API.put(`${ENDPOINTS.PUT_USER}/${userId}/status`, statusDetails);
	}

	/**
	* @param {*} userDetails
	*/
	async postUser(userDetails) {
		return API.post(`${ENDPOINTS.POST_USER}`, userDetails);
	}
	
	/**
	* @param {*} userId
	*/
	async putTransferUser(userId) {
		return API.put(`${ENDPOINTS.PUT_CUSTOMER}/primaryUser/${userId}`);
	}

	/**
	* @param {*} userId
	*/
	async resendLink(emailAddress) {
		return API.put(`${ENDPOINTS.PUT_USER}/${emailAddress}/activation-link`);
	}

	/**
	* @param {*} userId
	* @param {*} roleId
	*/
	async putUserRole(userId, roleId) {
		return API.put(`${ENDPOINTS.PUT_USER}/${userId}/role`, roleId);
	}


	async getUserAddress() {
		return API.get(ENDPOINTS.GET_ADDRESS);
	}

	/**
	 * Fetches the default addresses for a user based on the address type.
	 * 
	 * @async
	 * @param {string} addressType - The type of address to fetch (e.g., 'home', 'work').
	 * @returns {Promise<Object[]>} A promise that resolves to an array of address objects.
	 */
	async getUserDefaultAddresses(addressType) {
		return API.get(`${ENDPOINTS.GET_DEFAULT_ADDRESSES}?addressType=${addressType}`);
	}

	/**
	 * Deletes the default addresses for a user based on the provided details.
	 * 
	 * @async
	 * @param {Object} details - The details for deleting addresses.
	 * @param {string[]} details.addressIds - An array of address IDs to delete.
	 * @param {string} details.addressType - The type of addresses to delete.
	 * @returns {Promise<void>} A promise that resolves when the addresses have been deleted.
	 */
	async deleteUserDefaultAddresses(details) {
		return API.put(`${ENDPOINTS.DELETE_DEFAULT_ADDRESSES}`, details);
	}

	/**
	* @param {*} userAddress
	*/
	async postUserAddress(userAddress) {
		return API.post(`${ENDPOINTS.POST_ADDRESS}`, userAddress);
	}

	/**
	* @param {referenceId}
	*/
	async postCreateUser(referenceId) {
		return API.post(`${ENDPOINTS.POST_CREATE_USER}`, referenceId);
	}

	/**
	* @param {}
	*/
	async putDeactivateUser() {
		return API.put(`${ENDPOINTS.PUT_DEACTIVATE_USER}`);
	}


	async postAuthForgotPass(body) {
		return API.post(`${ENDPOINTS.POST_USER}/forgot-password`, body);
	}
}

export default new UserAPI();
